exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".goods-image[data-v-751d5116]{width:100%;height:480px;position:relative;display:-ms-flexbox;display:flex;z-index:500}.goods-image .larger[data-v-751d5116]{position:absolute;top:0;left:600px;width:480px;height:384px;box-shadow:0 0 10px rgba(0,0,0,.1);background-repeat:no-repeat;background-size:800px 800px;background-color:#f8f8f8;z-index:9999}.goods-image .middle[data-v-751d5116]{width:400px;height:320px;background:#f5f5f5;position:relative;cursor:move}.goods-image .middle .layer[data-v-751d5116]{width:200px;height:200px;background:rgba(0,0,0,.2);left:0;top:0;position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-751d5116","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ProductDetails.vue
// module id = 273
// module chunks = 2